import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Chip,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import IOSSwitch from "./IOSSwitch";
import { useGetList } from "../../hooks/useGetList";
import { useUpdate } from "../../hooks/useUpdate";

const RefundSettingsTable = () => {
  // Demo data
  const [refundSetting, setRefundSetting] = useState([
    { _id: 1, name: "Mdy Branch", refundModeOn: true },
    { _id: 2, name: "Sanchaung Branch", refundModeOn: false },
  ]);

  const { data, loading } = useGetList(`/setting/refund/global`);
  const { updateData } = useUpdate(`/setting/refund/global`);
  const [localData, setLocalData] = useState(null);

  console.log(data, "setting");

  // Sync local data with API data
  useEffect(() => {
    if (data?.data) {
      setLocalData(data.data);
    }
  }, [data]);

  console.log(localData, "localData");

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    settingId: null,
    branchName: "",
    currentStatus: false,
  });

  const handlePermissionToggle = (id) => {
    setConfirmDialog({
      open: true,
      settingId: id,
      branchName: localData?.name,
      currentStatus: localData?.refundModeOn,
    });
  };

  const handleConfirmToggle = async () => {
    const newStatus = !confirmDialog.currentStatus;
    const previousStatus = confirmDialog.currentStatus;

    // Update local state immediately for instant UI feedback
    setLocalData((prev) => ({ ...prev, refundModeOn: newStatus }));

    setConfirmDialog({
      open: false,
      settingId: null,
      branchName: "",
      currentStatus: false,
    });

    try {
      // Call API to update backend
      const result = await updateData("", {
        refundModeOn: newStatus,
      });

      // If API call failed (result is null), revert the change
      if (!result) {
        setLocalData((prev) =>
          prev.map((item) =>
            item._id === confirmDialog.settingId
              ? { ...item, refundModeOn: previousStatus }
              : item,
          ),
        );
        return;
      }

      console.log(
        `Permission updated for ${confirmDialog.branchName}: ${newStatus}`,
      );
    } catch (error) {
      // Revert the change if there's an unexpected error
      setLocalData((prev) =>
        prev.map((item) =>
          item._id === confirmDialog.settingId
            ? { ...item, refundModeOn: previousStatus }
            : item,
        ),
      );
      return;
    }
  };

  const handleCancelToggle = () => {
    setConfirmDialog({
      open: false,
      settingId: null,
      branchName: "",
      currentStatus: false,
    });
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Typography
        variant="h5"
        sx={{ mb: 3, fontWeight: 600, color: "#1a1a1a" }}
      >
        Refund Settings
      </Typography>

      <Typography variant="body2" sx={{ mb: 3, color: "#666" }}>
        Manage refundSetting permissions for each branch location
      </Typography>

      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="refundSetting settings table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#f8f9fa",
                    fontWeight: 600,
                    color: "#2c3e50",
                    borderBottom: "2px solid #e9ecef",
                  }}
                >
                  Branch Name
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#f8f9fa",
                    fontWeight: 600,
                    color: "#2c3e50",
                    borderBottom: "2px solid #e9ecef",
                  }}
                >
                  Refund Mode
                </TableCell>
              </TableRow>
            </TableHead>
            {/* <TableBody>
              {loading
                ? Array.from({ length: 5 }).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell>
                        <Skeleton variant="text" width="60%" />
                      </TableCell>
                      <TableCell>
                        <Skeleton
                          variant="rectangular"
                          width={52}
                          height={28}
                          sx={{ borderRadius: 14 }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                : refundSetting?.map((setting) => (
                    <TableRow
                      key={setting.id}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#f8f9fa",
                        },
                        transition: "background-color 0.2s ease-in-out",
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: 500,
                          color: "#2c3e50",
                          borderBottom: "1px solid #e9ecef",
                        }}
                      >
                        {setting.name}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: "1px solid #e9ecef",
                        }}
                      >
                        <IOSSwitch
                          checked={setting.refundModeOn}
                          onChange={() => handlePermissionToggle(setting._id)}
                          inputProps={{
                            "aria-label": `Refund permission for ${setting.name}`,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody> */}

            <TableBody>
              {loading ? (
                Array.from({ length: 5 }).map((_, index) => (
                  <TableRow key={`skeleton-${index}`}>
                    <TableCell>
                      <Skeleton variant="text" width="60%" />
                    </TableCell>
                    <TableCell>
                      <Skeleton
                        variant="rectangular"
                        width={52}
                        height={28}
                        sx={{ borderRadius: 14 }}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <>
                  <TableRow
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f8f9fa",
                      },
                      transition: "background-color 0.2s ease-in-out",
                    }}
                  >
                    <TableCell
                      sx={{
                        fontWeight: 500,
                        color: "#2c3e50",
                        borderBottom: "1px solid #e9ecef",
                      }}
                    >
                      {localData?.name}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderBottom: "1px solid #e9ecef",
                      }}
                    >
                      <IOSSwitch
                        checked={localData?.refundModeOn}
                        onChange={() => handlePermissionToggle(localData?._id)}
                        inputProps={{
                          "aria-label": `Refund permission for ${localData?.name}`,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={handleCancelToggle}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="confirm-dialog-title">
          Confirm Permission Change
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to{" "}
            {confirmDialog.currentStatus ? "disable" : "enable"} refund
            permissions for <strong>{confirmDialog.branchName}</strong>?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {confirmDialog.currentStatus
              ? "Disabling refund permissions will prevent this branch from requesting refunds."
              : "Enabling refund permissions will allow this branch to request refunds."}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelToggle} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmToggle}
            variant="contained"
            color={confirmDialog.currentStatus ? "error" : "success"}
          >
            {confirmDialog.currentStatus ? "Disable" : "Enable"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default RefundSettingsTable;
